export default __webpack_public_path__ + "static/0006-3bb99405bbee787a74ace07f874f2099.png";